import { createContext, useContext, type Context } from 'react'

import type { ChromeFlags } from '@/api/fe-common/getChromeFlags'

/** Every chrome flag off: the legacy header and footer, without Black Friday. */
export const OFF_CHROME_FLAGS: ChromeFlags = { isBrandRefresh: false, isBlackFriday: false, isBlackFridayPrereg: false }

// The header and footer flags the server render settled on (fe-common's decision, else this MFE's own),
// set in _app.tsx. The fallbacks read them from here rather than from props, because the Module
// Federation offline plugin renders them with the props the remote was given. Kept on globalThis so a
// second copy of this module, as the offline plugin can load on the server, shares the same context
// (fe-modern-template#92).
const CONTEXT_KEY = Symbol.for('fe-legacy-template.chromeFlags')
const registry = globalThis as typeof globalThis & { [CONTEXT_KEY]?: Context<ChromeFlags> }
const ChromeFlagsContext = (registry[CONTEXT_KEY] ??= createContext<ChromeFlags>(OFF_CHROME_FLAGS))

export const useChromeFlags = () => useContext(ChromeFlagsContext)

export default ChromeFlagsContext
